import { render, staticRenderFns } from "./SubFoldersABM.vue?vue&type=template&id=0a9243b6&scoped=true&"
import script from "./SubFoldersABM.vue?vue&type=script&lang=js&"
export * from "./SubFoldersABM.vue?vue&type=script&lang=js&"
import style0 from "./SubFoldersABM.vue?vue&type=style&index=0&id=0a9243b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9243b6",
  null
  
)

export default component.exports